<script lang="ts">
const effectOff = -18
</script>
<template>
  <div ref="element" class="infos" :style="styleOffset">
    <div class="card" :style="styleTranslateCardEffect">
      <span class="title">{{ title }}</span>
      <span class="description">{{ description }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
// @ts-ignore
import { spring } from 'vue3-spring';

interface Props {
  title: string;
  index: number;
  description: string;
  visible?: boolean;
  positions: number[];
  offsetX: number;
  containerWidth: number;
}

const props = defineProps({
  title: null,
  index: null,
  description: null,
  visible: { type: Boolean, default: true },
  positions: null,
  offsetX: null,
  containerWidth: null
});

const emit = defineEmits(["updatePostion"]);

const element = ref();

const { width } = useElementSize(element);

const styleOffset = computed(() => {
  const position = props.positions.reduce((pos, item, index) => {
    if (index < props.index) {
      pos += item;
    } else if (index === props.index) {
      pos += item * 0.5;
    }
    return pos;
  }, 0);

  return {
    transform: `translateX(${-position + props.offsetX}px)`,
  };
});

// card effect

const translateCard = ref<number>(effectOff);

const translateEffect = spring(translateCard, {
  damping: 13,
  stiffness: 100,
  mass: 1,
  from: translateCard.value,
});

const styleTranslateCardEffect = computed(() => {
  // const opacity = 1 - translateEffect.value / effectOff;
  return {
    transform: `translateY(${translateEffect.value}rem)`,
    // opacity,
  };
});

watchEffect(() => {
  emit('updatePostion', props.index, width.value);
});

watch(
  () => props.visible,
  (b) => {
    if (!b) {
      translateCard.value = effectOff;
    } else {
      translateCard.value = 0;
    }
  }
);
</script>
<style lang="scss" scoped>
.infos {
  display: flex;
  position: relative;
  width: 80%;
}
.card {
  @include stroke('n', 'n');

  display: flex;
  position: relative;
  z-index: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--gap_n);
  border-color: var(--color_neutral_100);
  background-color: var(--color_neutral_100);
  color: var(--color_neutral_900);
  text-align: left;
  gap: var(--gap_xxs);
}
.title {
  @include font('n', 700, 'secondary');

  z-index: 1;
}

.description {
  @include font('s', 400, 'secondary');

  z-index: 1;
}
</style>
